export const ramos = [{
	titulo: "Todos",
	secciones: []
},{
	titulo: "Gastos Médicos Mayores",
	secciones: [{titulo: "Cuestionario para la aplicación del beneficio de Cláusula Familiar o Protección Familiar"}, {titulo: "Reembolso"}, {titulo: "Programación de Cirugía"}, {titulo: "Programación de Tratamiento"}, {titulo: "Ayuda para Parto o Cesárea"}, {titulo: "Pago con Tarjeta"}, {titulo: "Accidentes Personales"}, {titulo: "Segunda y/o Tercera Opinión Médica"}, {titulo: "Otro"}]
},{
	titulo: "Vida",
	secciones: [{titulo: "Beneficios Adicionales"}, {titulo: "Reclamación Pérdidas Orgánicas"}, {titulo: "Reclamación Fallecimiento"}, {titulo: "Pago con Tarjeta"}, {titulo: "Otro"}]
},{
	titulo: "Autos",
	secciones: [{titulo: "Robo"}, {titulo: "Perdida Total"}, {titulo: "Pago con Tarjeta"},{titulo: "Pagos y Reembolsos"}, {titulo: "Otro"}]
},{
	titulo: "Daños",
	secciones: [{titulo: "Pago Siniestros El Palacio de Hierro"}, {titulo: "Otros"}]
}];



// WEBPACK FOOTER //
// ./src/mis-tramites/secciones.js